import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=3ff5c008&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=3ff5c008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5c008",
  null
  
)

export default component.exports